import { Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { PencilFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useOrdenation } from '../../../hooks/useOrdenation'
import { CustomButton } from '../../CustomButton'

export function ModalConsultarUnitarioKits({ isOpen, onClose, data }) {
  const { filteredItems, Th, Paginate } = useOrdenation(data, 'sku')

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Consultar Unitário em Kits</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {filteredItems.length > 0 && (
          <>
            <Table
              responsive
              hover
              bordered
              striped
            >
              <thead>
                <tr>
                  <Th
                    label="SKU"
                    value="sku"
                    style={{ fontSize: 12 }}
                  />

                  <Th
                    label="Descrição"
                    value="descricao"
                    style={{ fontSize: 12 }}
                  />

                  <th style={{ fontSize: 12 }}>Ações</th>
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((item) => (
                  <tr key={item.sku}>
                    <td style={{ fontSize: 12 }}>{item.sku}</td>
                    <td style={{ fontSize: 12 }}>{item.descricao}</td>

                    <td>
                      <Link
                        to={`/produtos/${item.codproduto}`}
                        target="_blank"
                      >
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                          <CustomButton color="#f54927">
                            <PencilFill fontSize={12} />
                          </CustomButton>
                        </OverlayTrigger>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
